var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"sign-tertiary marquee-text"},[_vm._v("\n        "+_vm._s(_vm.preface)+"\n        "),_c('transition',{attrs:{"duration":2000,"name":"marquee"}},[_c('span',{key:_vm.lines[_vm.current],staticClass:"marquee-dynamic"},[_vm._v("\n                "+_vm._s(_vm.lines[_vm.current])+"\n            ")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }